"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "kartleggVisningsdatastier", {
    enumerable: true,
    get: function() {
        return kartleggVisningsdatastier;
    }
});
var _get = /*#__PURE__*/ _interop_require_default(require("lodash/get"));
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
/**
  Rekursiv funksjon som bygger opp visningsdatasti for alle felt i kortdefinisjon.
  Visningsdatastien bygges opp av referansen til korttype, repeterendefelt, felt og feltMedEgenskaper.

  Når et felt har attributten "belopsfelt", splittes det til 2 visningsdatastier. Det blir en sti for feltet, og en
  sti for feltet med belopsfelt.

  Hvis feltet er "erFraForekomstKobling", byttes korttypens referanse med korttypens "forekomstKobling.referanse".
 */ var finnFelterOgReferanser = function(barnliste) {
    return (barnliste || []).flatMap(function(node) {
        if (node.type === "felt" || node.type === "feltMedEgenskaper") {
            var feltOgEventueltFeltMedEgenskaper = [
                {
                    id: node.id,
                    referanse: [
                        node.referanse
                    ],
                    erFraForekomstKobling: node.erFraForekomstKobling || false,
                    vedlegg: node.vedlegg || false,
                    referanseUtenFraForekomstKobling: []
                }
            ];
            if (node.type === "feltMedEgenskaper") {
                feltOgEventueltFeltMedEgenskaper.push({
                    id: node.belopsfelt.id,
                    referanse: [
                        node.referanse + "." + (0, _get.default)(node, "belopsfelt.referanse")
                    ],
                    erFraForekomstKobling: node.erFraForekomstKobling || false,
                    vedlegg: node.belopsfelt.vedlegg || false,
                    referanseUtenFraForekomstKobling: []
                });
            }
            return feltOgEventueltFeltMedEgenskaper;
        }
        var feltkjede = finnFelterOgReferanser(node.barnliste);
        feltkjede.forEach(function(f) {
            f.referanse = [
                node.type === "korttype" && f.erFraForekomstKobling ? node.forekomstKobling.referanse : node.referanse
            ].concat(_to_consumable_array(f.referanse)).filter(Boolean);
            f.referanseUtenFraForekomstKobling = [
                node.type === "korttype" && node.referanse
            ].concat(_to_consumable_array(f.referanseUtenFraForekomstKobling)).filter(Boolean);
        });
        return feltkjede || [];
    }).filter(Boolean);
};
var kartleggVisningsdatastier = function(visningsdefinisjon) {
    var filterPredikat = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {
        return true;
    };
    var feltliste = finnFelterOgReferanser(visningsdefinisjon).filter(filterPredikat);
    return feltliste.reduce(function(stiFraIdMap, felt) {
        stiFraIdMap[felt.id] = {
            referanse: felt.referanse.join("."),
            referanseUtenFraForekomstKobling: felt.referanseUtenFraForekomstKobling[0]
        };
        return stiFraIdMap;
    }, {});
};
